import { useState, useEffect, RefObject } from 'react';

interface UseScrollToBottomOptions {
  offset?: number;
  onlyIfHidden?: boolean;
}

export function useScrollToBottom(containerRef: RefObject<HTMLElement>, options: UseScrollToBottomOptions = {}) {
  const { offset = 0, onlyIfHidden = false } = options;
  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    if (shouldScroll && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const isBelowViewport = rect.bottom > window.innerHeight;

      if (!onlyIfHidden || isBelowViewport) {
        const scrollY = window.scrollY + rect.bottom + offset - window.innerHeight;
        window.scrollTo({ top: scrollY, behavior: 'smooth' });
      }
      setShouldScroll(false);
    }
  }, [shouldScroll, containerRef, offset, onlyIfHidden]);

  const triggerScroll = () => setShouldScroll(true);

  return { triggerScroll };
}
